module.exports = "https://img1.huilianyi.com/3/expense-claim.3d09f6325f.appcore.png";